/**
 * Notification preference HTTP. No toast (optimistic + revert, errors console only).
 */
import { useNotificationPreferenceStore } from '@/store/notification-preference.store.js';
import { Logger } from '@/lib/app-log.js';

export class NotificationPreferenceIntegration {
    constructor(sdkService) {
        this.service = sdkService;
    }

    async fetchPreferences() {
        const store = useNotificationPreferenceStore.getState();
        store.setLoading(true);
        try {
            const response = await this.service.getMyPreferences();
            if (response.success) {
                store.setPreferences(response.data);
                store.setLoading(false);
            }
        } catch (error) {
            Logger.error('Fetch notification preferences failed', { error: error?.message });
            store.setLoading(false);
        }
    }

    async updateAllPreferences(newData) {
        const store = useNotificationPreferenceStore.getState();
        const currentPrefs = store.preferences;
        const updatedPrefs = {
            ...currentPrefs,
            ...newData,
        };
        store.setPreferences(updatedPrefs);

        try {
            await this.service.updateMyPreferences(updatedPrefs);
        } catch (error) {
            Logger.error('Failed to update preference', { error: error?.message });
            store.setPreferences(currentPrefs);
        }
    }
}
